import advancedEu from '@wwdev/cookiebar/eu';

if (typeof euCookiebarConfig != 'undefined' && euCookiebarConfig.active == 1) {
    let myCookieBar = new advancedEu({
        text: {
            common: euCookiebarConfig.common_text,
            cookiemodal: {
                heading: euCookiebarConfig.modal.heading,
                intro: euCookiebarConfig.modal.text,
                category: {
                    necessary: {
                        label: euCookiebarConfig.modal.category.necessary.label,
                        label2: euCookiebarConfig.modal.category.necessary.label2,
                        text: euCookiebarConfig.modal.category.necessary.text
                    },
                    analytics: {
                        label: euCookiebarConfig.modal.category.analytics.label,
                        text: euCookiebarConfig.modal.category.analytics.text
                    },
                    advertisement: {
                        label: euCookiebarConfig.modal.category.advertisement.label,
                        text: euCookiebarConfig.modal.category.advertisement.text
                    },
                    functionality: {
                        label: euCookiebarConfig.modal.category.functionality.label,
                        text: euCookiebarConfig.modal.category.functionality.text
                    }
                },
                footer: {
                    buttons: {
                        accept: euCookiebarConfig.modal.footer.buttons.accept,
                        save: euCookiebarConfig.modal.footer.buttons.save
                    }
                }
            }
        },
        buttonText: {
            settings: euCookiebarConfig.buttons.settings,
            accept: euCookiebarConfig.buttons.accept
        }
    });
};
